


























import _ from 'lodash'
import { Component, Prop } from 'vue-property-decorator'
import VueExtendedBaseComponent from '@/VueExtendedBaseComponent.vue'

@Component
export default class TimelineLayout extends VueExtendedBaseComponent {
  @Prop({ default: '' }) public header!: string
}
